"use strict";

(function () {
  'use strict';

  angular.module('lr.Dashboard').controller('DashboardCtrl', DashboardCtrl);
  DashboardCtrl.$inject = ['Transactions', 'Utils', 'authEvents', 'User', '$lrNotifier', 'DataStreamFactory', 'StateFactory', '$scope', 'dataEvents'];
  /* @ngInject */

  function DashboardCtrl(Transactions, Utils, authEvents, User, $lrNotifier, DataStreamFactory, StateFactory, $scope, dataEvents) {
    /* jshint validthis: true */
    var EventStream = DataStreamFactory.generator();
    var State = StateFactory.State;
    var event = Utils.Publisher.subscribe(Utils.DateKeeper.event, function () {
      turnoverData();
      fetchEventHistory();
      getTodayCount();
      vm.currentDate = Utils.DateKeeper.getDate();
    }); //view model

    var vm = this;
    vm.transactions = {};
    vm.transactions.expected = {};
    vm.transactions.actual = {};
    vm.transactions.expected.Arrivals = 0;
    vm.transactions.expected.Departures = 0;
    vm.transactions.actual.CheckIns = 0;
    vm.transactions.actual.CheckOuts = 0;
    vm.liveEvents = EventStream;
    vm.checkInData = {};
    vm.activate = activate;
    vm.title = 'DashboardCtrl';

    vm.syncEvents = function (page) {
      fetchEventHistory(page);
    };

    var propertyStateEvents = Utils.Publisher.subscribe(dataEvents.propertyState, function () {
      turnoverData();
      getTodayCount();
    });

    if (!User.isAuthenticated()) {
      Utils.Publisher.subscribe(authEvents.success, function () {
        activate();
      });
    }

    if (User.isAuthenticated()) {
      activate();
    }

    $scope.$on('$destroy', function () {
      destroy();
    }); ////////////////

    function activate() {
      getOverAll();
      getTodayCount();
      turnoverData();
      vm.syncEvents();
      vm.currentDate = Utils.DateKeeper.getToday();
    }

    function getOverAll() {
      State.getOverallCount().then(function success(data) {
        vm.overall = [{
          'label': 'Pending',
          value: data.PendingProperties
        }, {
          'label': 'In Progress',
          'value': data.InProgressProperties
        }, {
          'label': 'Ready',
          'value': data.ReadyProperties
        }];
        vm.overallData = data;
      }, function fail(error) {
        console.log(error);
      });
    }

    function getTodayCount() {
      State.getCount(null, Utils.DateKeeper.getDate()).then(function success(data) {
        vm.todayCount = [{
          'label': 'Pending',
          value: data.PendingProperties
        }, {
          'label': 'In Progress',
          'value': data.InProgressProperties
        }, {
          'label': 'Ready',
          'value': data.ReadyProperties
        }];
        vm.todayData = data;
      }, function fail(error) {
        console.log(error);
      });
    }

    function destroy() {
      Utils.Publisher.unsubscribe(event);
      Utils.Publisher.unsubscribe(propertyStateEvents);
    }

    function turnoverData() {
      Transactions.getTurnoverData({
        date: Utils.lrDateFormat(Utils.DateKeeper.getDate())
      }).then(function (data) {
        vm.transactions.expected = data.data;
      });
      Transactions.getActual({
        date: Utils.lrDateFormat(Utils.DateKeeper.getDate())
      }).then(function (data) {
        vm.transactions.actual = data.data;
      });
    }

    function fetchEventHistory(page) {
      EventStream.fetchHistory(null, page);
    }
  }
})();